package tta.destinigo.talktoastro.feature_post.data.response

import androidx.compose.ui.graphics.drawscope.Stroke
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PostDetailsResponseData(
    @SerialName("created_at") val createdAt: String, // 2024-01-12 16:39:19
    @SerialName("expert_profile_image") val consultantProfile: String?, // https://live.winyway.com/images/UserImages/profileR0JTID05-51-52.jpg
    @SerialName("deleted_at") val deletedAt: String?, // null
    @SerialName("expert_category") val expertCategory: String?, // null
    @SerialName("expert_id") val expertId: Int, // 69
    @SerialName("expert_name") val expertName: String, // Jyoti
    @SerialName("id") val id: Int, // 613
    @SerialName("total_comments") val totalComments: String?, // 0
    @SerialName("total_likes") var totalLikes: String?, // 0
    @SerialName("total_shares") val totalShares: String?,// 0
    @SerialName("is_approved") val isApproved: Int, // 1
    @SerialName("is_delete") val isDelete: Int, // 0
    @SerialName("post_content") val postContent: String, // http://localhost/winywayapi/public/post_flies/1705057759.jpg
    @SerialName("post_content_type") val postContentType: String, // image
    @SerialName("post_creation_date") val postCreationDate: String, // 2024-01-12
    @SerialName("post_creation_time") val postCreationTime: String, // 16:39:19
    @SerialName("post_description") val postDescription: String, // test
    @SerialName("updated_at") val updatedAt: String, // 2024-01-12 19:13:26
    @SerialName("is_liked_by_me") var isLikedByMe: Boolean?, // 0
    @SerialName("user_id") val userId: String? // null
){
   // fun isLikedByMe():Boolean = _isLikedByMe ==1
}
